import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { SexoBiologico } from "../utils";

export const putDadosPessoaisAutonomo = async (params: {
  idAutonomo: string;
  celularComercial: string;
  celular: string;
  emailPessoal: string;
  nomeEmergencia: string;
  telefoneEmergencia: string;
  tipoContatoEmergencia?: string;
  filhos:
    | { nome?: string; dataNascimento?: Date | null; sexo?: SexoBiologico }[]
    | null;
  authToken: string;
}): Promise<any> => {
  const url = "/api/autonomo/AtualizarDadosPessoaisAutonomo";
  const { authToken, ...parameters } = params;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.put(url, parameters, config);
  return response?.data;
};
